import { connect } from 'react-redux'
import StatusFinished from './status-finished'
import {
  disconnectFromWonde,
  pullFromWonde
} from '../../../../../../../stores/school-data/school-data.actions'
import {
  getSchoolData,
  isSchoolUsingGroupCall
} from '../../../../../../../stores/school-data/school-data.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'
import dateFns from 'date-fns'

const mapStateToProps = state => {
  const school = getSchoolData(state)
  const usingGroupCall = isSchoolUsingGroupCall(state)
  return {
    id: school.id,
    statusColor: usingGroupCall ? 'green' : school.wonde.color,
    lastSync: usingGroupCall
      ? dateFns.format(school.groupcall.finished_at, 'DD/MM/YYYY H:s')
      : dateFns.format(school.wonde.last_update_at, 'DD/MM/YYYY H:s'),
    mis: usingGroupCall ? school.groupcall.mis : school.wonde.mis,
    usingGroupCall: usingGroupCall
  }
}

const mapDispatchToProps = dispatch => ({
  onDisconnect: schoolId =>
    dispatch(disconnectFromWonde(schoolId)).catch(errorHandler),
  onPull: schoolId => dispatch(pullFromWonde(schoolId)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusFinished)
